exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xbartable[data-v-07f0080c] {\n  width: 100%;\n  height: 100%;\n}\n.xbartable .th[data-v-07f0080c] {\n  height: 0.229167rem;\n}\n.xbartable .tr[data-v-07f0080c] {\n  padding-bottom: 0.052083rem;\n}\n.xbartable tr td[data-v-07f0080c] {\n  padding-right: 0.052083rem;\n}", ""]);

// exports
